<template>
  <div>
    <v-row class="ma-0">
      <strong class="mr-10 mt-2">タイプ</strong>
      <v-select
        :items="type"
        dense
        v-model="istype"
        class="text-field-search"
        outlined
      />
    </v-row>
    <v-row>
      <v-layout child-flex class="pad-top-button">
        <v-data-iterator
          :items="items"
          :loading="loadingData"
          :page="pagination.page"
          :items-per-page.sync="pagination.maxResultCount"
          hide-default-footer
        >
          <template v-slot:default="props">
            <v-row class="ma-0 cart-row">
              <v-col
                v-for="(item, index) in props.items"
                :key="item.name"
                class="cart-col"
              >
                <!-- Name -->
                <v-row class="cart-row-name">
                  <span>{{ item.name }}</span>
                  <v-spacer />
                  <v-icon
                    v-if="isEdit && isEdit.name !== item.name"
                    size="20"
                    @click="handleEdit(item)"
                    >fas fa-pencil-alt</v-icon
                  >
                  <v-icon
                    v-else
                    size="20"
                    :disabled="$v.$anyError"
                    @click="dialogConfirm = true"
                    >fas fa-check</v-icon
                  >
                </v-row>
                <!--  -->
                <v-row class="ma-0 mt-2">
                  <v-col class="pa-0" cols="4">
                    <span>よみ</span>
                  </v-col>
                  <v-col class="pa-0 ml-1">
                    <v-text-field
                      v-if="isEdit.name === item.name"
                      v-model="isEdit.read"
                      class="ml-5"
                      height="25"
                      dense
                      outlined
                      hide-details
                      :error-messages="nameErrors()"
                      @input="$v.isEdit.read.$touch()"
                      @blur="$v.isEdit.read.$touch()"
                    />
                    <span v-else class="ml-5">{{ item.read }}</span>
                  </v-col>
                </v-row>
                <base-error
                  v-if="isEdit.name === item.name"
                  :message="nameErrors()"
                  class="mt-1"
                ></base-error>
                <!--  -->
                <v-row class="ma-0 mt-1">
                  <v-col class="pa-0 pt-1" style="max-width: 80px">
                    <span>音声データ</span>
                  </v-col>
                  <v-col class="pa-0 ml-1 d-flex">
                    <audio
                      :ref="`audio-${index}`"
                      class="ml-3"
                      v-if="
                        item.sound_url &&
                        (!audio || !audio.fileUrl || isEdit.name !== item.name)
                      "
                    >
                      <source :src="item.sound_url" type="audio/mp3" />
                      Your browser does not support the audio element.
                    </audio>
                    <audio
                      :ref="`audio-${index}`"
                      class="ml-3"
                      :key="audio.fileUrl"
                      v-if="audio && audio.fileUrl && isEdit.name == item.name"
                    >
                      <source :src="audio.fileUrl" type="audio/mp3" />
                      Your browser does not support the audio element.
                    </audio>
                    <v-btn
                      fab
                      color="warning"
                      v-if="
                        item.sound_url &&
                        (!audio || !audio.fileUrl || isEdit.name !== item.name)
                      "
                      width="25"
                      height="25"
                      class="mt-1 ml-2"
                      @click="play(`audio-${index}`)"
                    >
                      <v-icon size="15">fas fa-volume-up</v-icon>
                    </v-btn>
                    <v-btn
                      fab
                      color="warning"
                      v-if="audio && audio.fileUrl && isEdit.name == item.name"
                      width="25"
                      height="25"
                      class="mt-1 ml-2"
                      @click="play(`audio-${index}`)"
                    >
                      <v-icon size="15">fas fa-volume-up</v-icon>
                    </v-btn>
                    <v-spacer />
                    <base-upload
                      v-if="isEdit.name == item.name"
                      type="audio"
                      v-model="audio"
                    >
                      <span slot="activator">
                        <v-btn icon>
                          <v-icon size="20">fas fa-upload</v-icon>
                        </v-btn>
                      </span>
                    </base-upload>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </template>
          <template v-slot:loading>
            <div class="text-center mt-5">読み込み中。。。待ってください。</div>
          </template>
          <template v-slot:no-data>
            <div class="mt-5 text-center">データがありません。</div>
          </template>
        </v-data-iterator>
      </v-layout>
    </v-row>
    <BasePagination
      v-if="items.length > 0"
      :pageCount="items.length"
      class="mt-4"
      :pageSize="pagination.maxResultCount"
      @changePage="changePage"
    />
    <Dialog v-model="dialogConfirm" title="確認">
      <template v-slot:content>保存します。よろしいですか。</template>
      <template v-slot:actions>
        <v-btn color="primary" @click="handleUpdate" small :loading="loading"
          >OK</v-btn
        >
        <v-btn color @click="handleCancelConfirm" small>キャンセル</v-btn>
      </template>
    </Dialog>
  </div>
</template>
<script>
import mixin from "@/mixin";
import Dialog from "@/components/Dialog/Dialog";
import BasePagination from "@/components/Pagination/BasePagination";
import uploadFile from "@/utils/uploadFile";
import { validationMixin } from "vuelidate";
import {
  getListDatetimeVocabulary,
  updateDatetimeVocabulary,
} from "@/api/DatetimeVocabulary.api";
export default {
  mixins: [mixin.App, validationMixin],
  components: {
    BasePagination,
    Dialog,
  },
  data() {
    return {
      type: [
        { text: "曜日", value: "WEEK" },
        { text: "日", value: "DAY" },
        { text: "月", value: "MONTH" },
      ],
      format: /[^\u3040-\u309f_＿/／]/g,
      istype: "WEEK",
      items: [],
      isEdit: {},
      audio: null,
      loadingData: false,
      dialogConfirm: false,
      audioPlay: "",
      loading: false,
    };
  },
  created() {
    this.handleGetListTime();
  },
  mounted() {
    this.pagination.pageCount = this.items.length;
  },
  validations() {
    return {
      isEdit: {
        read: {
          strongAnswers(text) {
            return !this.format.test(text); // checks for special char
          },
        },
      },
    };
  },
  watch: {
    // audio: function (val) {
    //   if (val) {
    //     this.items.find((e) => e.Id == this.isEdit.Id).sound_url = val.fileUrl;
    //   }
    // },
    istype: function () {
      this.handleGetListTime();
    },
  },
  methods: {
    async handleGetListTime() {
      const { istype } = this;
      this.loadingData = true;
      let params = {
        type: istype,
      };
      await getListDatetimeVocabulary(params).then(({ result, totalCount }) => {
        this.items = result;
        this.pagination.pageCount = totalCount;
      });
      this.loadingData = false;
    },
    handleCancelConfirm() {
      this.isEdit = {};
      this.audio = null;
      this.dialogConfirm = false;
    },
    handleEdit(item) {
      this.handleCancelConfirm();
      this.isEdit = { ...item };
    },
    async handleUpdate() {
      this.$v.$touch();
      if (!this.$v.$anyError) {
        const {
          isEdit: { Id, type, read, name },
        } = this;
        let params = {
          id: Id,
          type,
          read,
          name,
        };
        this.loading = true;
        await this.checkFile(params);
        await updateDatetimeVocabulary(params)
          .then(async () => {
            await this.handleGetListTime();
            this.handleCancelConfirm();
            this.loading = false;
          })
          .catch((error) => {
            this.$toast.error(error);
            this.loading = false;
          });
      }
    },
    async checkFile(params) {
      if (this.audio && this.audio.file) {
        await uploadFile(this.audio.file, "audio").then((e) => {
          params.sound = e;
        });
      }
      return params;
    },
    play(ref) {
      const { _ } = this;
      if (!this.audioPlay || this.audioPlay == ref) {
        if (this.$refs[ref][0].paused) {
          this.$refs[ref][0].play();
        } else {
          this.$refs[ref][0].pause();
        }
        this.audioPlay = ref;
      } else if (this.audioPlay && this.audioPlay != ref) {
        if (this.$refs[ref][0].paused) {
          _.forEach(this.$refs, (e) => {
            e[0].pause();
          });
          this.$refs[ref][0].play();
        }
        this.audioPlay = ref;
      }
    },
    changePage(value) {
      console.log("changePage: ", value);
      this.pagination.page = value;
    },
    nameErrors() {
      if (this.$v.isEdit.read.$dirty && !this.$v.isEdit.read.strongAnswers) {
        return "ひらがなを入力してください。";
      }
      return "";
    },
  },
};
</script>
<style scoped>
::v-deep
  .v-text-field--outlined.v-input--dense.v-text-field--outlined
  > .v-input__control
  > .v-input__slot {
  min-height: 30px;
}
</style>
<style lang="scss" scoped>
.cart-col {
  min-width: 230px;
  max-width: 230px;
  border: 1px solid #ccc;
  /* border-left: none; */
  margin: 8px;
  border-radius: 4px;
}

.cart-row-name {
  margin: 0;
  background-color: #bdbdbd;
  border-radius: 4px;
  padding: 4px 8px;
  font-weight: bold;
  /* margin-left: 6.2rem; */
}
</style>